'use strict';

angular.module('app')
    .controller('SearchDrCtrl', function($location, $scope, $rootScope, $routeParams, $timeout, GTM, utils, config, searchConfig, diviacLocalStorage, SearchDR, HomePage, locationInfo, locationCoordinates, leafletData, info, SeoService, Wishlist, gettextCatalog) {

        var vm = this,
            firstSeen = true, 
            firstMapOpen = locationInfo.model === 'Country', 
            filterObject = {},
            sliderOptions = {
                // price_sum_0: 0,
                // price_sum_1: 10000,
                options: {
                    floor: 0,
                    ceil: 10000,
                    step: 1,
                    translate: function(val) {
                        return $rootScope.setValue(val);
                    },
                    onEnd: toggleParameters,
                    hideLimitLabels: true
                }
            };
        
        vm.currentPage = 1;
        vm.currentSlug = $routeParams.slug;
        vm.locationCoordinates = locationCoordinates;
        vm.updateRoom = updateRoom;
        vm.formattedRoomsText = utils.formattedRoomsText
        vm.packageWarningMsg = packageWarningMsg;
        vm.roomsAndGuests = config.roomsAndGuests;
        vm.toggleParameters = toggleParameters;
        vm.updateRoom = updateRoom;
        vm.searchDR = searchDR;
        vm.clearAll = clearAll;
        vm.location = locationInfo;
        vm.showPinOnMap = showPinOnMap;
        vm.removeFocus = removeFocus;
        vm.isPackageAvaiableForCurrentCriteria = isPackageAvaiableForCurrentCriteria;
        vm.filtersCount = 0;
        vm.currentFilters = {};
        vm.bounds = {};
        vm.jumpToEmptyInput = jumpToEmptyInput;


        var translationListener = $rootScope.$watch('translationsUploaded', function(newVal) {
            if (newVal) {
                vm.roomsAndGuests[3].title = gettextCatalog.getString('More choices...')
                translationListener();
            }
        })


        vm.starRatingFilter = [1, 2, 3, 4, 5];
        vm.resortSize = searchConfig.RESORT_SIZE;
        vm.guestsRating = searchConfig.GUESTS_RATING;
        vm.sortBy = searchConfig.SORT_BY;
        vm.mealPlans = info.shop.RESORT_MEAL_PLANS;
        vm.sliderOptions = sliderOptions;
        vm.isAllParamsSelected = isAllParamsSelected;
        // vm.parameters = info.parameters[20];
        vm.triggerWishlist = triggerWishlist;
        vm.parameters = {
            resort_amenities: info.parameters[20][gettextCatalog.getString('Facilities')],
            dive_center_affiliations: info.parameters[20][gettextCatalog.getString('Affiliations')],
            diving_facilities: info.parameters[20][gettextCatalog.getString('Diving Facilities')],
            diving_equipment: info.parameters[20][gettextCatalog.getString('Equipment')]
        }
        vm.selectedParams = {
            from: diviacLocalStorage.get('date') &&  diviacLocalStorage.get('date')[0],
            // roomSelected: 2,
            duration: diviacLocalStorage.get('duration'),
            // price_sum_0: sliderOptions.price_sum_0,
            // price_sum_1: sliderOptions.price_sum_1,
        }

        var selectedRoom = diviacLocalStorage.get('roomParams');

        if (selectedRoom) {
            if (selectedRoom.id === 'auto') {
                vm.selectedParams.roomSelected = 'auto';
                vm.roomsAndGuests[2] = selectedRoom;
            } else {
                vm.selectedParams.roomSelected = selectedRoom.id;
            }
        }
        vm.noResultsAtAll = false;
        vm.redirectedFromLA  = window.sessionStorage.getItem('redirectedFromLA');
        // vm.redirectedFromLA = diviacLocalStorage.get("redirectedFromLA");
        window.sessionStorage.removeItem('redirectedFromLA');


        GTM.variables({
            destination_name: locationInfo.title,
            destination_id: locationInfo.pk
        });

        var filtersKeys = [
            'from',
            'duration',
            'totalGuests',
            'rating',
            'stars',
            'resort_size',
            // 'price_sum_0',
            // 'price_sum_1',
            'ordering',
            'total_number_of_rooms_1',
            'total_number_of_rooms_0',
            'meal_plan',
            'marine_life_critters',
            'parameters',
            'themes',
            'harbours',
            'duration',
            'price',
            'is_promotion',
            'sponsors',
            'view',
            'resort_amenities',
            'diving_facilities',
            'dive_center_affiliations',
            'diving_equipment'
        ],
        valueFilter = [
            'duration',
            'view',
            'from',
            // 'price_sum_0',
            // 'price_sum_1',
            'ordering'
        ],
        mainSearchFilters = [
            'duration',
            'view',
            'from',
            'roomSelected'
        ]

        if (locationInfo.pk) {
            vm.searchQuery = locationInfo.title;
        }

        var query = $location.search();

        if (query) {
            _.each(query, function(val, key) {
                if (filtersKeys.indexOf(key) >= 0) {
                    if (valueFilter.indexOf(key) >= 0) {
                        filterObject[key] = val;
                    } else {
                        if (_.isArray(val)) {
                            filterObject[key] = {};
                            _.each(val, function(v) {
                                filterObject[key][v] = true;
                            });
                        } else {
                            filterObject[key] = {};
                            filterObject[key][val] = true;
                        }
                    }
                }
            });
            
            angular.extend(vm.selectedParams, filterObject);
        }

        toggleParameters();

        function clearAll() {
            _.each(vm.selectedParams, function (val,key) {
                if (mainSearchFilters.indexOf(key) === -1) {
                    vm.selectedParams[key] = undefined;
                } 
            });

            // vm.selectedParams.price_sum_0 = 0;
            // vm.selectedParams.price_sum_1 = sliderOptions.price_sum_1;

            toggleParameters(1);
        }

        function toggleParameters(removePage) {
            var obj = {},
                filtersCount = 0

            _.each(vm.selectedParams, function(val, key) {
                val = _.cloneDeep(val);
                if (filtersKeys.indexOf(key) >= 0) {
                    if (valueFilter.indexOf(key) >= 0) {
                        obj[key] = val;
                    } else if (key === 'resort_size') {
                        obj[key] = _.filter(_.map(val, function(v, k) {
                            if (v) {
                                return +k;
                            } else {
                                return null;
                            }
                        }), function(v) {
                            return v || _.isNumber(v);
                        });
                        

                        var selectedOptions = _(searchConfig.RESORT_SIZE).filter(function(v) {
                            return obj[key].indexOf(v.id) !== -1;
                        }).value(),
                        roomNumbers = selectedOptions.reduce(function(acc, val) {
                            acc[0] = ( acc[0] === undefined || val.total_number_of_rooms_0 < acc[0] ) ? val.total_number_of_rooms_0 : acc[0]
                            acc[1] = ( acc[1] === undefined || val.total_number_of_rooms_1 > acc[1] ) ? val.total_number_of_rooms_1 : acc[1]
                            return acc;
                        },[]);

                        obj['total_number_of_rooms_0'] = roomNumbers[0];
                        if (roomNumbers[1] !== Infinity) {
                            obj['total_number_of_rooms_1'] = roomNumbers[1];
                        }
                    } else {
                        obj[key] = _.filter(_.map(val, function(v, k) {
                            if (v) {
                                return +k;
                            } else {
                                return null;
                            }
                        }), function(v) {
                            return v || _.isNumber(v);
                        });
                    }

                    if (_.isArray(obj[key]) && obj[key].length || key === 'is_promotion' && obj[key]) {
                        filtersCount++
                    }

                    $location.search(key, obj[key]);
                }
            });

            // if (+vm.selectedParams.price_sum_0 !== sliderOptions.price_sum_0 || +vm.selectedParams.price_sum_1 !== sliderOptions.price_sum_1) {
            //     filtersCount++
            // } else {
            //     $location.search('price_sum_0', null)
            //     $location.search('price_sum_1', null)
            // }

            vm.filtersCount = filtersCount;

            if (removePage) {
                if (_.isEmpty(vm.selectedParams)) {
                    _.each(filtersKeys, function(val) {
                        $location.search(val, null);
                    });
                }

                $location.search('page', 1);
                vm.currentPage = 1;
            }

            if (obj.duration) {
                diviacLocalStorage.set('duration', obj.duration);
            } else {
                diviacLocalStorage.remove('duration');
            }

            if (obj.rating && obj.rating.length) {
                obj.rating = Math.min.apply(null, obj.rating);
            }
            
            if (obj.from) {
                diviacLocalStorage.set('departure_date_custom', obj.from);
                diviacLocalStorage.set('date',[obj.from,moment(obj.from).add(30,'d').format('YYYY-MM-DD')]);
                diviacLocalStorage.remove('departure_date');
            } else {
                diviacLocalStorage.remove('departure_date');
                diviacLocalStorage.remove('departure_date_custom');
                diviacLocalStorage.remove('date');
            }
            vm.currentFilters = obj;

            if (vm.selectedShop) {
                loadShopData(vm.selectedShop.id);
            }
            
            // redirect to other area 
            if (vm.searchQuery.slug !== $routeParams.slug) {
                HomePage.startSearch();
            }

            if (vm.selectedParams.view === 'map') {
                mapMoved();
            }
            getShopList(obj);
        }


        function updateRoom(data) {
            var room = utils.selectRooms(data, vm.roomsAndGuests, isNaN(vm.selectedParams.roomSelected) ? vm.selectedParams.roomSelected : +vm.selectedParams.roomSelected);

            vm.selectedParams.roomSelected = room.filter;
            vm.roomsAndGuests = room.roomsAndGuests;
        }

        function getShopList(obj) {
            var preparedFilters = vm.selectedParams.roomSelected ? utils.setRoomParams(vm.selectedParams.roomSelected, vm.selectedParams) : {};
            
            angular.extend(vm.selectedParams,preparedFilters.filterParams);
            vm.selectedRoomText = utils.formattedRoomsText(preparedFilters.roomParams);

            vm.loader = true;
            
            var data = _.cloneDeep(vm.selectedParams);

            data.divers = data.diversByRoom;
            data.non_divers = data.nonDiversByRoom;
            data.students = data.studentsByRoom;
            data.guests = undefined;

            angular.extend(data, obj);


            // if (+vm.selectedParams.price_sum_0 === sliderOptions.price_sum_0 && +vm.selectedParams.price_sum_1 === sliderOptions.price_sum_1) {
            //     data.price_sum_0 = null;
            //     data.price_sum_1 = null;
            // }

            // if (vm.selectedParams.price_sum_0 === 0) {
            //     data.price_sum_0 = null;
            // }

            SearchDR.getShopList(locationInfo, data, { page: vm.currentPage }).then(function(data) {
                vm.loader = false;
                vm.shopList = data.results;
                vm.totalQty = data.count;

                getLocationDetails();         

                if (firstSeen) {
                    var string = '';
                }
                
                _.each(data.results, function(resort) {
                    resort.dateEnd = resort.dateStart ? moment(resort.dateStart).add(resort.nights, 'd').format('YYYY-MM-DD') : null;

                    if (_.isUndefined(string) === false) {
                        string += resort.shopId + ','
                    }
                })

                if (firstSeen && data.results.length && string) {
                    GTM.variables({ business_ids: string.slice(0,-1) });
                    firstSeen = false;
                }

                SeoService.generateMetaTags(gettextCatalog.getString('{{ qty }} Dive Resorts in {{ location }} | PADI Travel', { qty: vm.totalQty, location: locationInfo.title }),
                                            gettextCatalog.getString('Browse, compare and book {{ qty }} dive resorts in {{ location }}. Read divers reviews, check prices and verify amenities before booking.', {
                                                qty: vm.totalQty,
                                                location: locationInfo.title
                                            }))
            });
        }

        function getLocationDetails() {

            SearchDR.getLocationDetails(locationInfo, {
                duration: vm.selectedParams.duration,
                view: vm.selectedParams.view,
                from: vm.selectedParams.from,
                to: vm.selectedParams.to,
                guests: vm.selectedParams.guests,
                divers: vm.selectedParams.divers,
                nights: vm.selectedParams.nights,
                meal_plan: _.map(vm.selectedParams.meal_plan, function(v,k) { return k })
            }).then(function(data) {
                vm.locationDetails = data;
                if (vm.totalQty <= 0 ) {
                    //check if liveaboards from same country 
                    if (vm.locationDetails.destinationSlug == vm.currentSlug){
                        // when no results but there are liveaboards in this area - redirect there
                        if (vm.locationDetails.liveaboardsNumber > 0 && firstSeen) { 
                            redirectToLiveaboards();
                        }
                    } else {
                        //no results and no alternative liveaboards in this area
                        vm.noResultsAtAll = true;
                    }
                }

                // if (data.priceMax) {
                //     var priceMax = Math.round(+data.priceMax);
                //     vm.sliderOptions.options.ceil = priceMax;

                //     if (vm.selectedParams.price_sum_1 === sliderOptions.price_sum_1) {
                //         vm.selectedParams.price_sum_1 = priceMax;
                //     }

                //     sliderOptions.price_sum_1 = priceMax;
                // }
                
                // if (vm.selectedParams.price_sum_1 > vm.sliderOptions.options.ceil) {
                //     vm.selectedParams.price_sum_1 = vm.sliderOptions.options.ceil;
                // }
            });
        }

        function mapMoved() {
            if (vm.map) {
                var bounds = vm.map.getBounds(),
                    data = _.clone(vm.selectedParams);

                vm.bounds.leftBound = bounds.getSouthWest().wrap().lat + ',' + bounds.getSouthWest().wrap().lng;
                vm.bounds.rightBound = bounds.getNorthEast().wrap().lat + ',' + bounds.getNorthEast().wrap().lng;
                
                vm.markers = [];

                // if (+data === sliderOptions.price_sum_0 && +data === sliderOptions.price_sum_1) {
                //     data.price_sum_0 = null;
                //     data.price_sum_1 = null;
                // }
                
                vm.mapLoader = true;
                if (firstMapOpen && vm.selectedParams.view === 'map') {
                    data.country = locationInfo.pk
                    firstMapOpen = false;
                } else {
                    data.country = null
                }

                SearchDR.getMapInfo(vm.bounds, angular.extend(data, vm.currentFilters)).then(function(markers) {
                    _.each(markers, function(v) {
                        if (vm.selectedShop && v.info.id === vm.selectedShop.id) {
                            v.icon = config.mapIcons.markerViolet
                        }
                    });

                    if (vm.highlightedShop) {
                        vm.map.fitBounds(locationCoordinates);

                        if (markers.length) {
                            vm.highlightedShop = false;
                        }
                    }

                    vm.markers = markers;

                    vm.mapLoader = false;
                });
            }
        }

        function loadShopData(id) {
            vm.shopLoading = true;
            
            _.each(vm.markers, function(v) {
                v.icon = v.info.id === id ? config.mapIcons.markerViolet : config.mapIcons.withPrice;
            });

            var clonedParams = _.clone(vm.selectedParams);

            SearchDR.getShopDetailInfo(id, angular.extend(clonedParams, vm.currentFilters)).then(function(data) {
                vm.shopLoading = false;
                vm.selectedShop = data;
            })
        }

        function redirectToLiveaboards () {
            window.sessionStorage.setItem("redirectedFromDR",true);
            window.location.href = utils.createURL(vm.locationDetails.searchUrl);
        }

        function showPinOnMap(shop) {
            vm.highlightedShop = shop;
            vm.selectedShop = shop;

            SearchDR.triggerMap();

            mapMoved();
        }

        function searchDR(value) {
            if (value.length < 3) {
                return false;
            }

            return HomePage.search({
                q: value,
                kind: 20
            });
        }

        function removeFocus() {
            $timeout(function() {
                vm.elementFocused = false;
            }, 300);
        }

        angular.extend(vm, searchConfig.MAP_CONFIG);

        leafletData.getMap('search-map').then(function(m) {
            vm.map = m;
            vm.map.fitBounds(locationCoordinates);
        });
        
        $scope.$on('leafletDirectiveMap.search-map.dragend', _.debounce(mapMoved,1));
        $scope.$on('leafletDirectiveMap.search-map.zoomend',  _.debounce(mapMoved,350));
        $scope.$on('leafletDirectiveMarker.search-map.click', function(e, args) { 
            if (vm.selectedShop &&  args.model.info.shopId === vm.selectedShop.shopId) {
                return true;
            }
            
            loadShopData(args.model.info.shopId);
        });

        $scope.$on('leafletDirectiveMap.search-map.click', function (e, args){
            _.each(vm.markers, function (v) {
                v.icon = config.mapIcons.withPrice;
            });
            vm.selectedShop = null; 
        });

        function jumpToEmptyInput(preventReload, isDatepicker) {
            var inputs = {
                "#dateFrom": vm.selectedParams.from,
                "#durationSelect .selectize-input": vm.selectedParams.duration,
                "#roomsSelect .selectize-input": vm.selectedParams.roomSelected
            },
            error = false
            
            _.each(inputs, function(model, id) {

                if (!model) {
                    if (!isDatepicker) {
                        $(id).click();
                    }
                    error = true
                    return false;
                }
            })

            if (!error && !preventReload) {
                vm.toggleParameters(1)
            }
            
        }

        function isAllParamsSelected () {
            return vm.selectedParams.from && vm.selectedParams.duration && vm.selectedParams.roomSelected
        }

        function triggerWishlist (e, result) {
            e.stopPropagation();
            e.preventDefault();

            if (!$rootScope.user) {
                $rootScope.wishlist = result.slug;
                return;
            }

            var data = {item_type: 'Shop', item_slug: result.slug},
                type = 'add';

            if (result.isWishlist) {
                data = result.isWishlist;
                type = 'delete';
            }

            Wishlist[type](data).then(function (data) {
                if (result.isWishlist) {
                    result.isWishlist = false;
                }

                if (type === 'add') {
                    result.isWishlist = data.item.id;
                }
            });
        }

        function packageWarningMsg(shop) {
            var resortDateStart = moment(shop.dateStart).utc().format('YYYY-MM-DD')
            // Date start are the same but duration is not equal
            if (resortDateStart !== vm.selectedParams.from && shop.nights === vm.selectedParams.duration) {
                shop.errorMsg = gettextCatalog.getString('Dates are not an exact match with your search criteria. Only specific start dates are possible. Go to the resort page and open the date picker to see which ones.')
            // Date start is not the same but duration is equal
            } else if (shop.nights !== +vm.selectedParams.duration && resortDateStart === vm.selectedParams.from) {
                shop.errorMsg = gettextCatalog.getString('Duration is not an exact match with your search criteria. Only specific durations are possible. Go to the resort page and open the date picker to see which ones.')
            // Date start and duration not equal
            } else if (shop.nights !==  +vm.selectedParams.duration && resortDateStart !== vm.selectedParams.from) {
                shop.errorMsg = gettextCatalog.getString('Dates & duration are not an exact match with your search criteria. Only specific start dates & durations are possible. Go to the resort page and open the date picker to see which ones.')
            }

            return shop.errorMsg;
        }

        function isPackageAvaiableForCurrentCriteria(shop) {
            if (shop.availablePackageKinds === null) {
                return true
            }

            if (vm.selectedParams.nonDivers && shop.availablePackageKinds && shop.availablePackageKinds.length) {
                // 20 - non-diver package kind
                return shop.availablePackageKinds.indexOf(20) !== -1
            }

            return true
        }
    });